export default class GetUploadMetadataRequest {
  constructor(
    readonly parentId: string,
    readonly uploadIds: string[]
  ) { }
}